import {Component} from "@angular/core";
import {FUIVideoComponent} from "../video.component";

@Component({
    selector: "fui-background-video",
    templateUrl: "./background-video.component.html",
    styleUrls: ["./background-video.component.scss"],
    standalone: false
})
export class FUIBackgroundVideoComponent extends FUIVideoComponent {
    constructor() {
        super();
    }
}
